import { Controller } from "stimulus"
import JQuery from 'jquery'

export default class extends Controller {
  initialize() {
    this.element.querySelectorAll('[data-wordbank-word]').forEach((span) => {
      const data = span.dataset
      const type = data.wordbankType
      const word = data.wordbankWord
      const wordTranslated = data.wordbankWordTranslated
      const definition = data.wordbankDefinition
      const explanation = data.wordbankExplanation
      const explanationTranslated = data.wordbankExplanationTranslated

      let title = `<div class="flex justify-between"><span>${word}</span><em class="pl3">${type}.</em></div>`
      if (wordTranslated) {
        title = title + '<br/><strong>Translation:</strong><br/>' + wordTranslated
      }

      let content = definition || explanation
      if (explanationTranslated) {
        content = content + '<br/><strong>Translation:</strong><br/>' + explanationTranslated
      }

      JQuery(span).popover({
        container: this.element,
        title: title,
        html: true,
        content: content,
        trigger: 'hover focus',
        placement: 'top'
      })
    })
  }
}
